import { gql } from "@grandvisionhq/graphql";
const validationError = gql`
  fragment CartValidationErrorFragment on IValidationError {
    __typename
    defaultMessage
    validationCode
    passed
  }
`;
const cartSolvableError = gql`
  fragment CartSolvableErrorsFragment on SolvableValidationError {
    isSolvable
    ...CartValidationErrorFragment
    actionItem {
      lineItemId
      actioneeSKU
      action
    }
  }
  ${validationError}
`;
const cartLineItemError = gql`
  fragment CartLineItemErrorFragment on LineItemValidationError {
    __typename
    errors {
      __typename
      ...CartValidationErrorFragment
      ...CartSolvableErrorsFragment
    }
  }
  ${validationError}
  ${cartSolvableError}
`;
const cartValidationErrors = gql`
  fragment CartValidationErrorsFragment on CartValidationErrors {
    __typename
    cartErrors {
      __typename
      ...CartValidationErrorFragment
    }
    cartLineItemErrors {
      __typename
      ...CartLineItemErrorFragment
      itemId
    }
  }
  ${cartLineItemError}
  ${validationError}
`;
const cartFailures = gql`
  fragment CartFailuresFragment on CartResponseFailure {
    ... on ProductNoLongerExistsFailure {
      __typename
      sku
    }
    ... on CartNotFoundFailure {
      __typename
      id
    }
    ... on InvalidCartFailure {
      __typename
      message
    }
  }
`;
const createCartFromOrderFailures = gql`
  fragment CreateCartFromOrderFailuresFragment on CreateCartFromOrderFailure {
    ... on EmptyOrderLineItemsFailure {
      message
    }
    ... on HashedOrderNumberFailure {
      message
    }
  }
`;
export {
  cartFailures,
  cartLineItemError,
  cartSolvableError,
  cartValidationErrors,
  createCartFromOrderFailures,
  validationError
};
//# sourceMappingURL=cart-validation-errors.js.map
